export const getPageEventsReportTableRows = (data, isExtendedView = true) => {
	const rows = [];
	let index = 1;

	data?.forEach((variantData) => {
		const pageVariant = variantData?.pageVariant;
		const campaignsData = variantData?.data || [];

		let variantSourceSum = 0;
		let variantTargetSum = 0;

		campaignsData.forEach((campaignData) => {
			variantSourceSum += campaignData['sourceEventCount'] || 0;
			variantTargetSum += campaignData['targetEventCount'] || 0;
		});

		if (!isExtendedView) {
			rows.push(
				<tr key={`${pageVariant}-summary`}>
					<td>{index}</td>
					<td>{pageVariant}</td>
					<td>{variantSourceSum}</td>
					<td>{variantTargetSum}</td>
				</tr>,
			);
		}

		if (isExtendedView) {
			const rowSpanCount =
				campaignsData.length > 0 ? campaignsData.length + 1 : 1;

			if (campaignsData.length === 0) {
				rows.push(
					<tr key={`${pageVariant}-empty`}>
						<td>{index}</td>
						<td>{pageVariant}</td>
						<td>-</td>
						<td>0</td>
						<td>0</td>
					</tr>,
				);
			}

			if (campaignsData.length > 0) {
				campaignsData.forEach((campaignData, i) => {
					if (i === 0) {
						rows.push(
							<tr key={`${pageVariant}-${i}`}>
								<td rowSpan={rowSpanCount} style={{ verticalAlign: 'middle' }}>
									{index}
								</td>
								<td rowSpan={rowSpanCount} style={{ verticalAlign: 'middle' }}>
									{pageVariant}
								</td>
								<td>{campaignData['utm_campaign'] || '-'}</td>
								<td>{campaignData['sourceEventCount']}</td>
								<td>{campaignData['targetEventCount']}</td>
							</tr>,
						);
					}

					if (i > 0) {
						rows.push(
							<tr key={`${pageVariant}-${i}`}>
								<td>{campaignData['utm_campaign'] || '-'}</td>
								<td>{campaignData['sourceEventCount']}</td>
								<td>{campaignData['targetEventCount']}</td>
							</tr>,
						);
					}
				});

				rows.push(
					<tr
						key={`${pageVariant}-summary`}
						style={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}
					>
						<td style={{ textAlign: 'right' }}>Sum:</td>
						<td>{variantSourceSum}</td>
						<td>{variantTargetSum}</td>
					</tr>,
				);
			}
		}

		index++;
	});

	return rows;
};
